// assets/main-search.js

document.addEventListener('DOMContentLoaded', () => {
  // —————————————————————————————————————————————
  // Define SearchForm **before** you call define()
  // —————————————————————————————————————————————
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input    = this.querySelector('input[type="search"]');
      this.clearBtn = this.querySelector('button[data-clear]');
      if (!this.input || !this.clearBtn) return;

      // show/hide the clear‑X
      this.input.addEventListener('input', () => this.toggleClear());

      // clear‑X click handler
      this.clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.input.value = '';
        this.toggleClear();
        this.input.focus();
        this.input.dispatchEvent(new Event('input'));
      });

      this.toggleClear();
    }

    toggleClear() {
      if (this.input.value.length > 0) {
        this.clearBtn.classList.remove('hidden');
      } else {
        this.clearBtn.classList.add('hidden');
      }
    }
  }
  customElements.define('search-form', SearchForm);

  // —————————————————————————————————————————————
  // Wire up modal close‑X buttons to collapse their <details>
  // —————————————————————————————————————————————
  document.querySelectorAll('.modal__close-button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const details = btn.closest('details');
      if (details) details.open = false;
    });
  });
});

